// extracted by mini-css-extract-plugin
module.exports = {"containsRecommendations":"homePageProductRecommendations_containsRecommendations__MHAo_","recommendationsInner":"homePageProductRecommendations_recommendationsInner__dt_o6"};